module.exports = __webpack_public_path__ + "img/banner22.5d9c01fd.jpg";